import styled from "@emotion/styled";
import { BASE_COLORS, FONT_SIZES } from "../../../../../../../../../../emotion-theme";

export const HostContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export const SelectIcon = styled.div`
  font-size: ${FONT_SIZES.body};
  padding: 4px;
  margin: 16px 8px;
  text-align: center;
  width: 42px;
  height: 42px;
  line-height: 34px;
  vertical-align: middle;

  &:hover,
  &.selected {
    cursor: pointer;
    background-color: ${BASE_COLORS.lightGrey};
    font-weight: bold;
    border-radius: 50%;
    overflow: hidden;
  }
`;
